import { useMutation, useQuery } from "@tanstack/react-query";
import {
  checkUserAuth,
  logOutAccount,
  preLogin,
  resendInvitation,
  silentSignout,
} from "controller/api";
import { sentryLogger } from "utilz";
import { ApiErrorType } from "shared";

export const useLogoutAccount = () => {
  return useMutation(() => logOutAccount(), {
    onSuccess(data, variables, context) {},
  });
};

export const usePreLogin = () => {
  return useMutation((email: string) => preLogin(email), {
    onSuccess(data, variables, context) {},
  });
};

export const useResendInvitation = () => {
  return useMutation(
    (data: { userId: string; tenantId: string }) => resendInvitation(data),
    {
      onSuccess(data, variables, context) {},
      onError(error: ApiErrorType, variables, context) {
        sentryLogger({
          error: error,
          workflow: "auth",
          functionName: "resendInvitation",
        });
      },
    },
  );
};

export const useCheckUserAuth = (enabled?: boolean) => {
  return useQuery({
    queryKey: ["user_auth"],
    queryFn: () => checkUserAuth(),
    onError: (error) => console.log(error),
    enabled: enabled ? enabled : true,
  });
};

export const useSilentSignout = () => {
  return useMutation(
    (data: { clientId: string; token: string }) => silentSignout(data),
    {
      onSuccess(data, variables, context) {},
      onError(error: ApiErrorType, variables, context) {
        sentryLogger({
          error: error,
          workflow: "auth",
          functionName: "silentSignout",
        });
      },
    },
  );
};
